
import Vue from "vue"
import axios from "axios"
import { EventBus } from "@/plugins/eventBus"
import ETestingConnectionCard from "@/components/account/ETestingConnectionCard.vue"

export default Vue.extend({
  name: "AccountConnections",
  components: {
    ETestingConnectionCard,
  },
  data() {
    return {
      googleConnected: false,
      googleLoading: false,
      microsoftConnected: false,
      microsoftLoading: false,
      microsoftEnabled: false,
    }
  },
  created() {
    this.fetchStatus()
  },
  watch: {
    "$route.query.google"(val: string) {
      if (val === "connected") this.fetchStatus()
    },
    "$route.query.microsoft"(val: string) {
      if (val === "connected") this.fetchStatus()
    },
  },
  methods: {
    async fetchStatus() {
      try {
        const [googleRes, microsoftRes] = await Promise.allSettled([
          axios.get("/v1/calendar/google/status"),
          axios.get("/v1/calendar/microsoft/status"),
        ])
        this.googleConnected = googleRes.status === "fulfilled" && googleRes.value?.data?.connected === true
        if (microsoftRes.status === "fulfilled") {
          this.microsoftConnected = microsoftRes.value?.data?.connected === true
          this.microsoftEnabled = true
        } else {
          this.microsoftEnabled = false
        }
      } catch {
        this.googleConnected = false
        this.microsoftConnected = false
      }
    },
    async connectGoogle() {
      this.googleLoading = true
      try {
        const response = await axios.get("/v1/calendar/google/oauth/url")
        const url = response.data?.url
        if (url) {
          globalThis.location.href = url
        } else {
          EventBus.$emit("snackbar", {
            message: this.$vuetify.lang.t("$vuetify.google_oauth_url_error"),
            color: "error",
          })
        }
      } catch (error) {
        EventBus.$emit("snackbar", { axiosError: error })
      } finally {
        this.googleLoading = false
      }
    },
    async disconnectGoogle() {
      this.googleLoading = true
      try {
        await axios.delete("/v1/calendar/google/disconnect")
        this.googleConnected = false
        EventBus.$emit("snackbar", {
          message: this.$vuetify.lang.t("$vuetify.google_calendar_disconnected"),
          color: "success",
        })
      } catch (error) {
        EventBus.$emit("snackbar", { axiosError: error })
      } finally {
        this.googleLoading = false
      }
    },
    async connectMicrosoft() {
      if (!this.microsoftEnabled) return
      this.microsoftLoading = true
      try {
        const response = await axios.get("/v1/calendar/microsoft/oauth/url")
        const url = response.data?.url
        if (url) {
          globalThis.location.href = url
        } else {
          EventBus.$emit("snackbar", {
            message: this.$vuetify.lang.t("$vuetify.microsoft_oauth_url_error"),
            color: "error",
          })
        }
      } catch (error) {
        EventBus.$emit("snackbar", { axiosError: error })
      } finally {
        this.microsoftLoading = false
      }
    },
    async disconnectMicrosoft() {
      this.microsoftLoading = true
      try {
        await axios.delete("/v1/calendar/microsoft/disconnect")
        this.microsoftConnected = false
        EventBus.$emit("snackbar", {
          message: this.$vuetify.lang.t("$vuetify.microsoft_calendar_disconnected"),
          color: "success",
        })
      } catch (error) {
        EventBus.$emit("snackbar", { axiosError: error })
      } finally {
        this.microsoftLoading = false
      }
    },
  },
})
